import { render, staticRenderFns } from "./fllOrderDetail.vue?vue&type=template&id=04d075d1&scoped=true&"
import script from "./fllOrderDetail.vue?vue&type=script&lang=js&"
export * from "./fllOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./fllOrderDetail.vue?vue&type=style&index=0&id=04d075d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d075d1",
  null
  
)

export default component.exports